<ng-container [ngSwitch]="intakeView">
  <quick-lead-intake-host *ngSwitchCase="intakeViewValues.ONE_PAGE">
  </quick-lead-intake-host>

  <social-intake-host *ngSwitchCase="intakeViewValues.SOCIAL_SIGN_UP">
  </social-intake-host>

  <ng-template *ngSwitchDefault [ngTemplateOutlet]="standardFlows">
  </ng-template>
</ng-container>

<ng-template #standardFlows>
  <div class="host-router flowsHostPanel sonder-formlib-light-background">
    <div
      class="flows-router-spinner"
      *ngIf="wizardSvc.response?.slug == null; else flowHost"
    >
      <div class="flow-spinner-container">
        <mat-spinner
          diameter="88"
          strokeWidth="6"
          aria-label="Loading Match Flow"
        ></mat-spinner>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #flowHost>
  <ng-container *ngIf="shouldUseFlowsIntake; else oldHost">
    <flows-intake-host></flows-intake-host>
  </ng-container>
  <ng-template #oldHost>
    <flows-host></flows-host>
  </ng-template>
</ng-template>